import React from "react";
import DOMPurify from "dompurify";

import { formatCurrency } from "helpers/formatCurrency";

import "./_style.scss";
import CurrencyChip from "components/CurrencyChip/CurrencyChip";
import TextTranslator from "components/TranslateText/TextTranslator";

export const createDonationToCampaignLabel = (data, i, formProps, handlers, donationFormContext, overrides = {}) => {
  const {
    values: {
      donationAmount,
      perksCart,
    },
  } = formProps;

  const { feeStructure } = data;
  const title = donationFormContext?.target?.title;
  const currency = overrides.currency || feeStructure.currency;
  const currencySymbol = overrides.currencySymbol || feeStructure.currencySymbol;

  return (
    perksCart
      ? (
        <div className="donation-form__line-item --donation donation-campaign-label__container">
          <span className="donation-form__line-item-label">
            <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(`${perksCart && (perksCart?.count || 0)} &times; ${perksCart && perksCart?.title}`) }} />
            :
          </span>
          <span className="donation-form__line-item-value" data-test="donation-form-perk-total">
            {formatCurrency(donationAmount, feeStructure, false)}
          </span>
        </div>
      )
      : (
        <div className="donation-form__line-item --donation donation-campaign-label__container" key={i}>
          <span className="donation-form__line-item-label">
            <TextTranslator>To</TextTranslator>
            {" "}
            <span>{title}</span>
            :
          </span>
          <span className="donation-form__line-item-value">
            {currency && (
              <CurrencyChip currency={currency.toUpperCase()} size="small" hasMargin />
            )}
            { formatCurrency(donationAmount, { currencySymbol }, false) }
          </span>
        </div>
      )
  );
};
